import PointExpiringListTable from './pointExpiringListTable.container';

export default PointExpiringListTable